import Joi from "joi";

const charctersPattern = new RegExp(
  "^[A-Za-z\u0621-\u063A\ufe70-\ufeff\u0641-\u064A][A-Za-z\u0621-\u063A\ufe70-\ufeff\u0641-\u064A. ]+$"
);
export const EditStudentSchema = {
  name: Joi.string()
    .trim()
    .required()
    .pattern(charctersPattern)
    .min(3)
    .max(60)
    .messages({
      "string.empty": "Student Name is required",
      "string.max": "Student Name Validation",
      "string.min": "Student Name Validation",
      "string.pattern.base": "Student Name Validation",
    }),
  studentId: Joi.string()
    .trim()
    .allow("")
    .messages({ "string.pattern.base": "ScoolId Validation" }),
  classId: Joi.number()
    .required()
    .messages({ "number.empty": "teacher is required" }),
  email: Joi.string()
    .trim()
    .email({ tlds: { allow: false } })
    .allow("")
    .messages({
      "string.email": "EmailValidation",
    }),
};

export default EditStudentSchema;
